/*
 * PDP Swatch Overlay (miiva)
 * Legt die Farbauswahl (Swatch-Block) NUR auf Mobil (<900px) schwebend unten links
 * auf das erste Produktbild (Galerie). Auf Desktop (Collage) bleibt alles wie gehabt.
 *
 * Sicher: Es wird der KOMPLETTE Options-Block als Einheit verschoben (Inputs + Labels
 * zusammen). Die Radio-Inputs sind ueber form="product-form-..." gebunden und die Labels
 * ueber for/id -> Formular-Bindung, Auswahlstatus und Change-Events bleiben intakt.
 */
(function () {
  var BP = '(max-width: 899px)';
  var GALLERY_SEL = '.wt-product__gallery';
  var OPTIONS_SEL = '.wt-product__options';
  var MOVED_CLASS = 'wt-swatch-overlay';
  var ON_CLASS = 'has-swatch-overlay'; // auf <html> gesetzt, solange verschoben

  var mq = window.matchMedia(BP);
  var placeholder = null; // Kommentar-Anker fuer die Original-Position

  function gallery() {
    return document.querySelector(GALLERY_SEL);
  }

  // Options-Block, der NICHT bereits in der Galerie liegt
  function sourceOptions() {
    var all = document.querySelectorAll(OPTIONS_SEL);
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest(GALLERY_SEL)) return all[i];
    }
    return null;
  }

  function moveToGallery() {
    var g = gallery();
    var o = sourceOptions();
    if (!g || !o) return;
    if (!placeholder || !placeholder.parentNode) {
      placeholder = document.createComment('wt-swatch-overlay-anchor');
      o.parentNode.insertBefore(placeholder, o);
    }
    o.classList.add(MOVED_CLASS);
    g.appendChild(o);
    document.documentElement.classList.add(ON_CLASS);
  }

  function restore() {
    var moved = document.querySelector(GALLERY_SEL + ' .' + MOVED_CLASS);
    if (moved) {
      if (placeholder && placeholder.parentNode) {
        // Normalfall: zurueck an die Original-Position
        placeholder.parentNode.insertBefore(moved, placeholder);
      } else {
        // Anker verloren (z.B. Block per AJAX neu gerendert). Frueher blieb der
        // Options-Block dann in der Galerie haengen -> auf Desktop lagen die
        // Farbkreise faelschlich auf dem Produktbild. Fallback: zurueck in die
        // Info-Spalte; die genaue Position regelt dort ohnehin die CSS-order.
        var host =
          document.querySelector('[data-block-id="variant_picker_rRGmFz"]') ||
          document.querySelector('.wt-product__info');
        if (host) host.appendChild(moved);
      }
      moved.classList.remove(MOVED_CLASS);
    }
    document.documentElement.classList.remove(ON_CLASS);
  }

  function apply() {
    // Nur MOBIL (<900px) die Swatches aufs Bild legen; auf Desktop bleiben sie
    // in der Info-Spalte (neue Desktop-Anordnung).
    if (mq.matches) moveToGallery();
    else restore();
  }

  function init() {
    apply();

    // Falls die Variantenauswahl per AJAX neu rendert und den Options-Block ersetzt:
    // erneut verschieben. Debounced via requestAnimationFrame gegen Mehrfach-Trigger.
    var host = document.querySelector('.wt-product') || document.body;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (mq.matches && sourceOptions()) {
          placeholder = null; // alter Anker evtl. mit-neugerendert
          moveToGallery();
        }
      });
    });
    if (host) obs.observe(host, { childList: true, subtree: true });

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
